module.exports = __webpack_public_path__ + "img/domijn2.c387ab1e.jpg";